import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
//Farshid
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";
import ReactPlayer from 'react-player';

import CreditCardForm from "./CreditCardForm.js";

//import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
//import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//End Farshid



const Styles = theme => ({
    root: Object.assign({}, AppBackground, MediumFont),
    gridPane: {width: '50%', display: 'inline-block'},
    paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
    videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
    penInfoPanel: {color: 'white', fontSize: 20},
    penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
    videoPanel: {marginTop: 0},
    penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
    metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing.unit,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
    rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        margin: theme.spacing.unit,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
    dividerColorPurpole: {
        height: '20px',
        color:"#ffffff",
    },

    multilineColor:{
        color:'black',
        backgroundColor:'#f5f7e8'
    }
});

const GREEN       = '#1a736a';
const GREEN_LIGHT = '#f0f7f5';
const DARK        = '#1a2e1d';
const GRAY        = '#555';

const PROBLEMS = [
  {
    title: 'Overwatering & Root Rot',
    img: '/static/images/orchid-roots-original-pot-720x960.jpg',
    see: 'Mushy, dark brown roots; soft or yellowing lower leaves; soggy bark that never seems to dry.',
    cause: 'Watering too often, or using a pot without drainage. Orchid roots need air between waterings — sitting in wet conditions rots them.',
    fix: 'Let the bark dry slightly between waterings. Remove mushy roots when repotting. Orchima\'s drain valve helps you water thoroughly and drain completely every time.',
  },
  {
    title: 'Lack of Air Circulation',
    img: '/static/images/Orchidfungus.png',
    see: 'Dark spots or fuzzy patches on leaves; fungal growth near the base or in crowded roots.',
    cause: 'Still, stuffy rooms limit airflow. Orchids grow naturally in breezy trees — they need moving air to stay healthy and fight off fungus.',
    fix: 'Place your orchid near a gentle fan, or in a room with natural ventilation. Avoid closed cabinets or tightly crowded plant shelves.',
  },
  {
    title: 'Too Much Direct Sunlight',
    img: '/static/images/Sunburn-Spot-on-Orchid-Foliage.jpg',
    see: 'Bleached, white, or papery patches on leaves — often on the side facing the window. Leaves may look washed out.',
    cause: 'Direct afternoon or midday sun is too intense for orchids. They need bright light, but indirect.',
    fix: 'Move the orchid back from the window, or add a sheer curtain to filter the light. East-facing windows are the safest choice.',
  },
  {
    title: 'Low Humidity / Wrinkled Leaves',
    img: '/static/images/OrchidWrinkled.jpg',
    see: 'Leaves look wrinkled, puckered, or feel a little soft when you press them gently. Buds may dry up before opening.',
    cause: 'Dry indoor air — especially common with central heating or AC running. Orchids prefer 50–70% humidity.',
    fix: 'Place a shallow tray of pebbles and water beneath the pot to add humidity. Or run a small humidifier nearby. Avoid misting leaves directly, which can cause spots.',
  },
  {
    title: 'Wrong Potting Medium',
    img: '/static/images/OrchidWithMoss.jpeg',
    see: 'Water drains slowly or stays in the pot. Roots look flat, gray, or brown even after watering.',
    cause: 'Regular potting soil or sphagnum moss stays too wet. Orchid roots need air to function — dense media suffocates them and leads to rot.',
    fix: 'Repot into medium-grade orchid bark. Bark drains quickly and lets roots breathe. Avoid sphagnum moss for long-term growing.',
  },
  {
    title: 'Won\'t Rebloom',
    img: '/static/images/OrchidNoBloom.png',
    see: 'A healthy-looking plant with green leaves — but no new flower spike after many months.',
    cause: 'Not enough light, no nighttime temperature drop, or insufficient fertilizing during the growing season. Orchids need a 10–15°F cooler night to trigger a new bloom.',
    fix: 'Move near a brighter window. Try placing on a windowsill in early fall for the natural temperature drop. Feed with orchid fertilizer every 1–2 weeks in spring and summer.',
  },
  {
    title: 'Wrong Pot Choice',
    img: '/static/images/orchidceramicpot.jpg',
    see: 'Roots look dark or crowded; orchid seems to decline despite careful watering.',
    cause: 'Solid decorative pots with no drainage trap water at the bottom. Orchids need both drainage and airflow around their roots.',
    fix: 'Use a pot with drainage holes. Orchima™ solves this by design — you get the clean look of a decorative pot with proper drainage built right in.',
  },
];


class OrchidProblems extends Component {

    state = {
        age: '',
        name: 'hai',
        firstname: '',
        lastname:'',
        email:'',
        comment:'',
        userComment:{},
        selectedUser:{},
        showOrderForm:false
    };

    constructor(props) {
        super(props);

        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleEmailChange= this.handleEmailChange.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.saveVisitorComment = this.saveVisitorComment.bind(this);

        this.handleAddress2Change = this.handleAddress2Change.bind(this);
        this.handleShowOrderFormChange = this.handleShowOrderFormChange.bind(this);

    }


    componentDidMount() {
        const { isAuthenticated ,updateUserProfileAction} = this.props;
        updateUserProfileAction(null, this.props.loginData.accessToken);
    }


    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleShowOrderFormChange = event => {
        this.setState({ showOrderForm:!this.state.showOrderForm });
    };

    handleFirstNameChange(event) {
        this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));
    }

    handleLastNameChange(event) {
        this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));
    }

    handleEmailChange(event) {
        this.setState(Object.assign(this.state.userComment,{email:event.target.value}));
    }

    handleCommentChange(event) {
        this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
    }

    saveVisitorComment(){
        const {saveAComment} = this.props;
        var  returnString="";
        var tempLastName =  this.state.userComment.lastname;
        var tempFirstName = this.state.userComment.firstname;
        var tempEmail = this.state.userComment.email;
        var tempComment = this.state.userComment.comment;

        if((tempFirstName == null) || (tempFirstName.length == 0)){
            alert("Please provide your first name!");
        }else {
            if ((tempLastName == null) || (tempLastName.length == 0)) {
                alert("Please provide your last name!");
            }else {
                if ((tempEmail == null) || (tempEmail.length == 0)) {
                    alert("Please provide your Email!");
                } else {
                    if ((tempEmail.indexOf("@") == -1)) {
                        alert("Please provide proper Email address!");
                    }else{
                        if ((tempComment == null) || (tempComment.length == 0)) {
                            alert("Please provide your comment!");
                        }else{
                            saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);
                        }
                    }
                }
            }
        }

        return returnString;
    }

    handleAddress2Change(event) {
        this.setState(Object.assign(this.state.selectedUser,{address2:event.target.value}));
    }


    render() {
        return (
            <div style={{ backgroundColor: '#f9f9f7', minHeight: '100vh' }}>

                {/* Top nav */}
                <div style={{ backgroundColor: DARK, padding: '14px 24px' }}>
                    <a href="/home" style={{ color: '#ffffff', textDecoration: 'none', fontSize: 14, fontWeight: 600, letterSpacing: 0.5 }}>
                        ← Back to Orchima Home
                    </a>
                </div>

                {/* Hero */}
                <div style={{ backgroundColor: GREEN, padding: '56px 24px', textAlign: 'center' }}>
                    <p style={{ fontSize: 12, fontWeight: 700, color: '#a8d5cf', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 12, marginTop: 0 }}>
                        TROUBLESHOOTING GUIDE
                    </p>
                    <h1 style={{ fontSize: 'clamp(24px, 5vw, 36px)', fontWeight: 700, color: '#ffffff', lineHeight: 1.3, margin: '0 auto 16px auto', maxWidth: 600 }}>
                        Something Wrong with Your Orchid?
                    </h1>
                    <p style={{ fontSize: 17, color: '#d0ede9', maxWidth: 560, margin: '0 auto', lineHeight: 1.7 }}>
                        Most problems have a simple fix. Find your symptom below.
                    </p>
                </div>

                {/* Problem cards */}
                <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px' }}>

                    {PROBLEMS.map((problem, i) => (
                        <div key={i} style={{ backgroundColor: '#ffffff', borderRadius: 10, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', marginBottom: 28, overflow: 'hidden' }}>
                            {/* Card header */}
                            <div style={{ backgroundColor: DARK, padding: '16px 24px' }}>
                                <h2 style={{ fontSize: 20, fontWeight: 700, color: '#ffffff', margin: 0 }}>{problem.title}</h2>
                            </div>
                            {/* Card body */}
                            <div style={{ padding: '24px 24px' }}>
                                <div style={{ marginBottom: 20 }}>
                                    <img
                                        src={problem.img}
                                        alt={problem.title}
                                        style={{ maxWidth: '100%', width: '100%', maxHeight: 260, objectFit: 'cover', borderRadius: 8 }}
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                                    <div style={{ borderLeft: '4px solid #BF360C', paddingLeft: 14 }}>
                                        <p style={{ fontSize: 12, fontWeight: 700, color: '#BF360C', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6, marginTop: 0 }}>What you see</p>
                                        <p style={{ fontSize: 15, color: GRAY, lineHeight: 1.7, margin: 0 }}>{problem.see}</p>
                                    </div>
                                    <div style={{ borderLeft: '4px solid #aaa', paddingLeft: 14 }}>
                                        <p style={{ fontSize: 12, fontWeight: 700, color: '#777', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6, marginTop: 0 }}>Why it happens</p>
                                        <p style={{ fontSize: 15, color: GRAY, lineHeight: 1.7, margin: 0 }}>{problem.cause}</p>
                                    </div>
                                    <div style={{ borderLeft: '4px solid #1a736a', paddingLeft: 14, backgroundColor: GREEN_LIGHT, borderRadius: '0 8px 8px 0', padding: '14px 14px 14px 14px' }}>
                                        <p style={{ fontSize: 12, fontWeight: 700, color: GREEN, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6, marginTop: 0 }}>What to do</p>
                                        <p style={{ fontSize: 15, color: '#333', lineHeight: 1.7, margin: 0 }}>{problem.fix}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* Cross-link */}
                    <div style={{ backgroundColor: GREEN_LIGHT, borderRadius: 10, padding: '24px 28px', marginBottom: 48, textAlign: 'center' }}>
                        <p style={{ fontSize: 16, color: DARK, fontWeight: 600, marginBottom: 12, marginTop: 0 }}>
                            Want to prevent these problems in the first place?
                        </p>
                        <a href="/orchideducation" style={{ color: GREEN, fontWeight: 600, fontSize: 16, textDecoration: 'none' }}>
                            Read the Orchid Care Guide →
                        </a>
                    </div>

                    <div style={{ textAlign: 'center', paddingBottom: 24 }}>
                        <a href="/home" style={{ color: GREEN, fontWeight: 600, fontSize: 16, textDecoration: 'none' }}>
                            ← Back to Orchima Home
                        </a>
                    </div>

                </div>
            </div>
        );
    }
}

OrchidProblems.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        isAuthenticatedBool: state.login.isAuthenticatedBool,
        userProfile: state.login.userProfile,
        loginData:state.login.loginData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateUserProfileAction:updateUserProfileAction,
        saveAComment:saveAComment,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OrchidProblems));
